var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13805_7099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "url(#paint0_linear_13805_7099)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3784 36.3598L28.5866 15.1041C28.0907 14.0052 27.3536 13.4691 26.382 13.4691H25.6047C24.633 13.4691 23.8959 14.0052 23.4 15.1041L19.5737 24.365H16.6789C15.8144 24.3717 15.1108 25.0686 15.1041 25.9397V25.9598C15.1108 26.8242 15.8144 27.5278 16.6789 27.5346H18.2335L14.5815 36.3598C14.5144 36.5541 14.4742 36.7552 14.4742 36.9629C14.4742 37.4588 14.6284 37.8474 14.9031 38.149C15.1779 38.4505 15.5732 38.598 16.0691 38.598C16.3974 38.5913 16.7124 38.4907 16.9737 38.2964C17.2552 38.1021 17.4495 37.8206 17.6036 37.499L21.6242 27.5278H24.4119C25.2763 27.5211 25.9799 26.8242 25.9866 25.9531V25.9129C25.9799 25.0485 25.2763 24.3449 24.4119 24.3382H22.9242L25.9933 16.6923L34.3562 37.4923C34.5103 37.8139 34.7047 38.0954 34.9861 38.2897C35.2474 38.484 35.5691 38.5846 35.8907 38.5913C36.3866 38.5913 36.7753 38.4438 37.0567 38.1423C37.3382 37.8407 37.4856 37.4521 37.4856 36.9562C37.4923 36.7552 37.4588 36.5474 37.3784 36.3598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13805_7099",
    x1: 45.3864,
    y1: 9.68996,
    x2: 6.6984,
    y2: 42.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6509E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EBAC6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13805_7099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/Aave.fcde145a5df1a404fa82df32733f13a3.svg";
export { ForwardRef as ReactComponent };